import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BomCookieService } from 'src/app/core/services/bom-cookie/bom-cookie.service';
import { TooltipContainer } from './models/tooltip-container';
import { TutorialSequence } from './models/tutorial-sequence';
import { Tutorials } from './models/tutorials';

@Injectable({
  providedIn: 'root',
})
export class TutorialService {
  tutorialSequences: TutorialSequence[];
  isMenuLocked$: Observable<boolean>;
  currentActiveStep$ = new BehaviorSubject<TooltipContainer>(null);

  constructor(private cookieService: BomCookieService) {
    const tutorials = new Tutorials();
    this.tutorialSequences = tutorials.sequences;

    this.isMenuLocked$ = this.currentActiveStep$.pipe(
      map(x => {
        return !!x && x.lockScrollbar;
      })
    );
  }

  triggerNextStepForSequence(tutorialSequenceId: string) {
    const tutorialSequence = this.tutorialSequences.find(
      tutSeq => tutSeq.id === tutorialSequenceId
    );
    const currentStep = this.currentActiveStep$.value.step;
    if (currentStep + 1 > tutorialSequence.maxSteps) {
      this.currentActiveStep$.next(null);
    } else {
      this.currentActiveStep$.next({
        tutorialSequenceId: tutorialSequenceId,
        step: currentStep + 1,
        maxSteps: tutorialSequence.maxSteps,
        titleResourceKey: tutorialSequence.tooltips[currentStep].titleResourceKey,
        descriptionResourceKey: tutorialSequence.tooltips[currentStep].descriptionResourceKey,
        arialabelResourceKey: tutorialSequence.tooltips[currentStep].arialabelResourceKey,
        lockScrollbar: tutorialSequence.tooltips[currentStep].lockScrollbar,
      });
    }
  }

  setDontShowAgain(isChecked: boolean, tutorialSequenceId: string) {
    const tooltipCookieId = this.calculateSequenceCookieId(tutorialSequenceId);
    isChecked
      ? this.cookieService.set(tooltipCookieId, 'true')
      : this.cookieService.delete(tooltipCookieId);
  }

  enableSequence(sequenceId: string) {
    const hideSequence = this.isInHideStateFromCookie(sequenceId);
    if (!hideSequence) {
      const tutorialSequence = this.tutorialSequences.find(tutSeq => tutSeq.id === sequenceId);
      this.currentActiveStep$.next({
        tutorialSequenceId: sequenceId,
        step: 1,
        maxSteps: tutorialSequence.maxSteps,
        titleResourceKey: tutorialSequence.tooltips[0].titleResourceKey,
        descriptionResourceKey: tutorialSequence.tooltips[0].descriptionResourceKey,
        arialabelResourceKey: tutorialSequence.tooltips[0].arialabelResourceKey,
        lockScrollbar: tutorialSequence.tooltips[0].lockScrollbar,
      });
    }
  }

  disableSequence() {
    this.currentActiveStep$.next(null);
  }

  private isInHideStateFromCookie(sequenceId: string): boolean {
    const sequenceCookieId = this.calculateSequenceCookieId(sequenceId);
    const sequenceHideState = this.cookieService.get(sequenceCookieId);
    return sequenceHideState === 'true';
  }

  private calculateSequenceCookieId(sequenceId: string) {
    return `hide_tutorial_${sequenceId}`;
  }
}
